export class EngagementAnalytics {
  charts: {
    network_counts: any
    spend_by_network: any
    conversions_by_time: any
    revenue: {
        total_revenue: string
    }
  }

  constructor() {
    this.charts = {
      network_counts: {},
      spend_by_network: {},
      conversions_by_time: {},
      revenue: {
        total_revenue: "0",
      },
    }
  }
}